import React from 'react';
import { Row, Col, Space } from 'antd';
import ServiceEntry from './ServiceEntry';

class Team extends React.Component {

  render() {
    const { user, service } = this.props;

    return (
      <Row style={{ width: '100%', marginBottom: 12 }}>
        <h1>{service.domain_group}</h1>
        <Row style={{ width: '100%' }}>
          {
            service.service_entries && service.service_entries.map((serviceEntry, key) => {
              return (
                <Col xl={6} lg={6} md={8} sm={12} xs={24} key={key}>
                  <ServiceEntry serviceEntry={serviceEntry} user={user} />
                </Col>
              )
            })
          }
        </Row>
      </Row>
    )
  }
}

export default Team;